import React from "react";
import {
    StyledStatusWrapperCell
} from "@asd-stan/standard/components/standard-list/table-cells/status-cell.styled";
import { StandardStatus } from "@asd-stan/standard/domain/standard-status.entity";

interface StatusCellProps {
    statuses: string[];
}

export const StatusCell: React.FC<StatusCellProps> = ({ statuses }) => {
    return (
        <StyledStatusWrapperCell className="statuses">
            {statuses.map((status: string, i: number) => (
                <div style={getStyleByStatus(status)} key={i}>{status}</div>
            ))}
        </StyledStatusWrapperCell>
    );
};

const availableStatuses = [
    {
        status: StandardStatus.EN.toString(),
        backgroundColor: 'rgba(94, 217, 77, 0.16)',
        color: 'rgba(94, 217, 77, 1)',
    },
    {
        status: StandardStatus.PB.toString(),
        backgroundColor: 'rgba(29, 198, 6, 0.16)',
        color: 'rgba(29, 198, 6, 1)',
    },
    {
        status: 'CS – Coversheet',
        backgroundColor: 'rgba(44, 128, 218, 0.16)',
        color: 'rgba(44, 128, 218, 1)',
    },
    {
        status: StandardStatus.ENWIP.toString(),
        backgroundColor: 'rgba(11, 147, 227, 0.16)',
        color: 'rgba(11, 147, 227, 1)',
    },
    {
        status: StandardStatus.SD.toString(),
        backgroundColor: 'rgba(94, 79, 162, 0.16)',
        color: 'rgba(94, 79, 162, 1)',
    },
    {
        status: StandardStatus.WIP.toString(),
        backgroundColor: 'rgba(229, 121, 0, 0.16)',
        color: 'rgba(229, 121, 0, 1)',
    },
    {
        status: 'OH – On hold',
        backgroundColor: 'rgba(218, 166, 0, 0.16)',
        color: 'rgba(218, 166, 0, 1)',
    },
    {
        status: StandardStatus.AN.toString(),
        backgroundColor: 'rgba(91, 91, 91, 0.16)',
        color: 'rgba(91, 91, 91, 1)',
    },
    {
        status: StandardStatus.RT.toString(),
        backgroundColor: 'rgba(162, 79, 159, 0.16)',
        color: 'rgba(162, 79, 159, 1)',
    },
    {
        status: StandardStatus.DC.toString(),
        backgroundColor: 'rgba(11, 178, 126, 0.16)',
        color: 'rgba(11, 178, 126, 1)',
    },
];


const getStyleByStatus = (status: string) => {
    const match = availableStatuses.find((s) => s.status === status);

    return {
        backgroundColor: match?.backgroundColor || 'rgba(200, 200, 200, 0.16)',
        color: match?.color || "black",
    };
};

